import $http from '@Config/axios';

const prefix = 'calendario';

export const CalendarioPresenter = {
	upload: formData => $http.post(`${prefix}/bulk_update`, formData)
};
